import styled from 'styled-components';


const SpinnerRoot = styled.div`
	display: inline-flex;
`;


export {
	SpinnerRoot,
}
